import {Box, Typography} from '@mui/material';
import {ReactComponent as HighSpeedText} from '../../../../assests/svg/high_speed_text.svg';
import {ReactComponent as Illustration} from '../../../../assests/svg/Illustration.svg';
import {ReactComponent as LockIcon} from '../../../../assests/svg/security-lock-icon.svg';
import {ReactComponent as LockSmIcon} from '../../../../assests/svg/lock-sm-icon.svg';
import {ReactComponent as UploadHighSpeed} from '../../../../assests/svg/upload-high-speed.svg';
import {ReactComponent as UploadSmIcon} from '../../../../assests/svg/upload-sm-Icon.svg';
import AurButton from '../../../common/aur-button/AurButton';
import AurIcon, {IconColors, IconNames} from '../../../common/aur-icon/AurIcon';
import {t} from 'i18next';
import AurLoadingIndicator from '../../../common/aur-loading-indicator/AurLoadingIndictor';
import {useFileCatalystDownload} from '../../../../hooks/upload-evidence-source/useFileCatalystDownload';
import { useAnalytics } from '../../../../hooks/useAnalytics';
import { GA_CLICK_TYPES, GA_EVENT_NAMES, GA_REGIONS, GA_SUBPAGE_TYPE } from '../../../../constants/analyticsConstants';
const FileCatalystUnavailableScreen = () => {
  const {downloadFileCatalyst, isDownloading, progress} =
    useFileCatalystDownload();
        const {trackGAEvent} = useAnalytics();
    

  const submitHandler = async () => {
  trackGAEvent({
                  eventName: GA_EVENT_NAMES.CLICK,
                  click: {
                    name: t('gaTracking.uploadEvidence.getFilecatalyst'),
                    type: GA_CLICK_TYPES.BUTTON,
                    region: GA_REGIONS.TAB,
                    action: t('gaTracking.uploadEvidence.uploadFileDownloadFilecatalyst')
                  },
                  
                  subPage: {
                  subpage_name : t('gaTracking.uploadEvidence.highSpeedUpload'),
                  subpage_type : GA_SUBPAGE_TYPE.TAB
                  }
                });
    await downloadFileCatalyst();
  };

  return (
    <Box className="unavailable-screen-container">
      <Box className="flex-layout">
        <Box className="workflow-left">
          <HighSpeedText
            className="high-speed-text"
            role="img"
            aria-label={t('fileCatalyst.highSpeedUpload')}
            tabIndex={0}
          />
          <Typography className="typo-text headline1_size" tabIndex={0}>
            {t('fileCatalyst.highSpeedUploads.speedUpWorkflow')}
          </Typography>

          <Box tabIndex={0}>
            <Typography className="typo-text body2_size workflow-text-color">
              {t('fileCatalyst.highSpeedUploads.fileCatalystTrAgentOperates')}
            </Typography>

            <Typography className="workflow-text-color second-para">
              {t('fileCatalyst.highSpeedUploads.clickButtonInstruction')}
            </Typography>
          </Box>

          <AurButton
            type="continue"
            label={t('fileCatalyst.highSpeedUploads.getFileCatalyst')}
            title={t('fileCatalyst.highSpeedUploads.getFileCatalyst')}
            size="Large"
            disabled={isDownloading}
            classNames="workflow-button"
            onClick={submitHandler}
            endIcon={
              isDownloading ? (
                <AurLoadingIndicator size={20} className="button-loader" />
              ) : (
                <AurIcon
                  icon={IconNames.ArrowForward}
                  color={IconColors.Custom}
                  customClassName="button-icon"
                />
              )
            }
            ariaDescription={t('fileCatalyst.highSpeedUploads.getFileCatalyst')}
          />

          {isDownloading && progress > 0 && (
            <Box className="download-progress workflow-button">
              Downloading... {progress}%
            </Box>
          )}
        </Box>

        <Box className="workflow-right">
          <Illustration />
        </Box>
      </Box>

      <Box className="flex-layout container-border padding-top-40">
        <Box className="workflow-left section-two">
          <Box className="lock-icon-sm-device">
            <LockSmIcon />
          </Box>
          <Typography className="typo-text headline3_size" tabIndex={0}>
            {t('fileCatalyst.highSpeedUploads.approvalRequired')}
          </Typography>
          <Typography className="typo-text workflow-text-color">
            <Box tabIndex={0}>
              <span className="typo-text subhead4_size work-flow-title-color">
                {t('fileCatalyst.highSpeedUploads.orgApproval')}
              </span>

              <span className="typo-text body2_size">
                {' '}
                {t('fileCatalyst.highSpeedUploads.fromInfo')}
              </span>

              <ul className="workflow-list">
                <li>{t('fileCatalyst.highSpeedUploads.systemRestriction')}</li>
                <li>{t('fileCatalyst.highSpeedUploads.companyApproval')}</li>
                <li>{t('fileCatalyst.highSpeedUploads.workRegulatedInd')}</li>
              </ul>
            </Box>
            <Box className="it-matters-para">
              <span
                className="typo-text subhead4_size work-flow-title-color"
                tabIndex={0}
              >
                {t('fileCatalyst.highSpeedUploads.whyItMatters')}
              </span>
              <br />
              <span tabIndex={0}>
                {t('fileCatalyst.highSpeedUploads.transAgentInteract')}
              </span>
            </Box>
          </Typography>
        </Box>

        <Box className="workflow-right">
          <LockIcon />
        </Box>
      </Box>

      <Box className="flex-layout">
        <Box className="workflow-left section-two">
          <Box className="lock-icon-sm-device">
            <UploadSmIcon />
          </Box>
          <Typography className="typo-text headline3_size" tabIndex={0}>
            {t('fileCatalyst.highSpeedUploads.whatIsFileCatalyst')}
          </Typography>
          <Box tabIndex={0}>
            <Typography className="typo-text workflow-text-color">
              <span className="typo-text subhead4_size work-flow-title-color">
                {t('fileCatalyst.highSpeedUploads.fileCatalyst')}
              </span>
              <span className="typo-text body2_size">
                {'  '}{' '}
                {t('fileCatalyst.highSpeedUploads.fileCatalystDefination')}
              </span>
            </Typography>

            <Typography className="second-para">
              <span className="typo-text body2_size workflow-text-color">
                {t('fileCatalyst.highSpeedUploads.unLikeTradMethod')}
              </span>
              <span className="typo-text subhead4_size">
                {'  '}
                {t('fileCatalyst.highSpeedUploads.10gbps')}
              </span>
              <span className="typo-text body2_size workflow-text-color">
                {'  '} {t('fileCatalyst.highSpeedUploads.makingDeal')}
              </span>
            </Typography>
          </Box>

          <Typography>
            <span tabIndex={0}>
              <span className="typo-text subhead4_size">
                {t('fileCatalyst.highSpeedUploads.transferAgent')}
              </span>
              <span className="typo-text body2_size workflow-text-color">
                {'  '}
                {t('fileCatalyst.highSpeedUploads.lightWeightApp')}
              </span>
            </span>
          </Typography>
        </Box>

        <Box className="workflow-right">
          <UploadHighSpeed />
        </Box>
      </Box>
    </Box>
  );
};

export {FileCatalystUnavailableScreen};
